import {memo, VFC, createContext} from 'react';
import {useStateStore} from '@/pages/Store';
import {pathHandle} from './_routes';

interface Props {
    path?: string;
}

// @ts-ignore
const skeletonContexts = require.context('./../skeleton', true, /\/index\.tsx$/);

const getSkeleton = (path?: string): VFC | undefined => {
    if (!path) {
        return;
    }
    const skeletonMap: {
        [key: string]: string;
    } = {};
    skeletonContexts?.keys()?.forEach((relativePath: string) => {
        skeletonMap[pathHandle(relativePath)] = relativePath;
    });
    if (skeletonMap[path]) {
        return skeletonContexts(skeletonMap[path])?.default;
    }
};

export const skeletonContext = createContext(true);

const Skeleton: VFC<Props> = props => {
    const PageSkeleton = getSkeleton(props.path);
    const {
        displaySkeleton,
    } = useStateStore();

    return (
        <>
            {PageSkeleton && displaySkeleton && <PageSkeleton />}
        </>
    );
};

export default memo(Skeleton);
